import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.white,
  fillHoverColor: colors.white,
  iconColor: colors.duskBlue,
  iconHoverColor: colors.deepWater,
  iconBorderColor: colors.duskBlue,
  iconBorderHoverColor: colors.deepWater
};
export default socialIcon;